import { Pipe, PipeTransform } from '@angular/core';
import { ConsentsTranslations } from '@app/shared/models/consents-translations';

@Pipe({
  name: 'getConsentsTranslation',
})
export class GetConsentsTranslationPipe implements PipeTransform {
  public transform(consentsTranslations: ConsentsTranslations, consentKey: string, subKey?: string): string {
    return consentsTranslations.getConsentTranslation(consentKey, subKey);
  }
}
